/**
 * Custom Field Directive, used for custom fields on extras
 */
bookingApp.directive('skFlybuys', function(){
    return {
        require:'ngModel',
        link: function($scope, elem, attrs, ctrl){

            ctrl.$validators.number = function(modelValue, viewValue){
                if (ctrl.$isEmpty(modelValue)) {
                    return true;
                }
                return FlyBuys.valid(modelValue);
            };
        }
    };
});
bookingApp.directive('skCustomField', function(){
    return {
        scope: {
            type:'=?',
            label:'=?',
            field: '=?',
            entity: '=?',
            errormessages: '=?',
            attributes: '=?',
            account: '=?',
        },
        require: 'ngModel',
        replace: true,
        controller: function($scope, sessionFactory){
            $scope.session = sessionFactory;
            // Fetch all the available field types
            $scope.types = $scope.session.customFieldTypes;
            $scope.isDirty = false;
        },
        template:
        '<div class="custom-fields-container" ng-form>' +
            '<div ng-form="textField" class="sk-input-group sk-custom-text col-xs-12 inactive" sk-text ng-if="type === types.text" ng-class="{\'has-error\': (isDirty) && subModel.$error.length, \'sk-selected\':(value)}">' +
                '<label class="custom-field-label">{{label}}<span class="required-tag" ng-if="attributes.cfRequired">*<span></label>' +
                '<input type="text" ng-model="value" class="custom-field-element custom-field-text" ng-minlength="{{attributes.cfMinLength}}" ng-maxlength="{{attributes.cfMaxLength}}" ng-required="attributes.cfRequired" />' +
            '</div>' +
            '<div ng-form="emailField" class="sk-input-group sk-custom-email col-xs-12 inactive" sk-email ng-if="type === types.email" ng-class="{\'has-error\': (isDirty) && (subModel.$error.length), \'sk-selected\':(value || (isDirty && subModel.$error.length))}">' +
                '<label class="custom-field-label">{{label}} <span class="required-tag" ng-if="attributes.cfRequired">*<span></label>' +
                '<input type="email" ng-model="value" class="custom-field-element custom-field-text" />' +
            '</div>' +
            '<div ng-form="numberField" class="sk-input-group sk-custom-number col-xs-12 inactive" sk-number ng-if="type === types.number" ng-class="{\'has-error\': (isDirty) && (subModel.$error.length),\'sk-selected\':(value || (isDirty && subModel.$error.length))}">' +
                '<label class="custom-field-label">{{label}}<span class="required-tag" ng-if="attributes.cfRequired">*<span></label>' +
                '<input type="number" ng-model="value" class="custom-field-element custom-field-text" ng-min="attributes.cfMin" ng-max="attributes.cfMax" min="{{attributes.cfMin}}" max="{{attributes.cfMax}}" ng-required="attributes.cfRequired"/>' +
            '</div>' +
            '<div ng-form="dateField" class="sk-input-group sk-custom-date col-xs-12 inactive" sk-date safe-apply="safeApply" ng-if="type === types.date" ng-class="{\'has-error\': (isDirty) && subModel.$error.length}">' +
                '<label class="custom-field-label">{{label}} <span class="required-tag" ng-if="attributes.cfRequired">*<span></label>' +
                '<input type="date" ng-model="value" class="custom-field-element custom-field-date" min="{{attributes.cfMinDate}}" max="{{attributes.cfMaxDate}}" ng-max="attributes.maxDate" ng-min="attributes.minDate" ng-required="attributes.cfRequired"/>' +
            '</div>' +
            '<div ng-form="cardField" class="sk-input-group sk-custom-card col-xs-12 inactive" sk-text ng-if="type === types.card" ng-class="{\'sk-selected\':(value || ((isDirty) && (cardField.$invalid))), \'has-error\':(isDirty) && subModel.$error.length}">' +
                '<label class="custom-field-label">{{label}}<span class="required-tag" ng-if="attributes.cfRequired">*<span></label>' +
                '<input type="text" ng-model="value" ng-model-options="{updateOn: \'blur\'}" sk-flybuys class="custom-field-element custom-field-text" ng-required="cfRequired"/>' +
            '</div>' +
            '<div ng-form="textareaField" class="sk-input-group sk-custom-textarea col-xs-12 inactive" sk-text-area ng-if="type === types.textarea" ng-class="{\'has-error\': (isDirty) && (subModel.$error.length), \'sk-selected\':(value)}">' +
                '<label class="custom-field-label">{{label}}<span class="required-tag" ng-if="attributes.cfRequired">*<span></label>' +
                '<textarea class="custom-field-element custom-field-text" ng-model="value" ng-minlength="attributes.cfMinLength" ng-maxlength="attributes.cfMaxLength" ng-required="attributes.cfRequired"></textarea>' +
            '</div>' +
            '<div class="sk-input-group col-xs-12 inactive sk-custom-select" ng-class="{\'multi-select\':(field.multi), \'sk-selected\':(value)}" sk-select custom-field="true" ng-if="type === types.select">' +
                '<label class="custom-field-label">{{label}}<span class="required-tag" ng-if="attributes.cfRequired">*<span></label>' +
                '<select ' +
                    'ng-if="field.multi === true" ' +
                    'multiple ' +
                    'class="custom-field-element" ' +
                    'ng-model="value" ' +
                    '>' +
                    '<option ng-repeat="option in field.radioOptions" ng-value="option.id" ng-if="option.id !== \'_empty\'">{{option.label}}</option>' +
                '</select>' +
                '<select ' +
                    'ng-if="field.multi === false" ' +
                    'class="custom-field-element" ' +
                    'name="selectCustomField" ' +
                    'ng-model="value">' +
                    '<option ng-repeat="option in field.radioOptions" ng-value="option.id" ng-if="option.id !== \'_empty\'" ng-selected="value === option.id">{{option.label}}</option>' +
                '</select>' +
            '</div>' +
            '<div class="sk-group sk-input-group radio-group col-xs-12" ng-if="type === types.radio">' +
                '<label class="custom-field-label">{{label}} <span class="required-tag" ng-if="attributes.cfRequired">*<span></label>' +
                '<md-radio-group ng-model="value" class="custom-field-element" data-required="attributes.cfRequired">' +
                    '<md-radio-button ng-repeat="item in field.radioOptions" aria-label="{{item.label}}" ng-value="item.id" ng-click="toggleSelection(item.id, value)">{{item.label}}</md-radio-button>' +
                '</md-radio-group>' +
            '</div>' +
            '<div class="sk-group sk-input-group list-group col-xs-12" ng-if="type === types.checkbox" ng-class="{\'sk-checkbox-readonly \':field.readOnly}">' +
                '<label ng-if="field.readOnly === false" class="custom-field-label">{{label}}<span class="required-tag" ng-if="attributes.cfRequired">*<span></label>' +
                '<md-list>' +
                '<md-list-item ng-if="field.readOnly === false" class="custom-field-element">' +
                    '<md-checkbox ng-repeat="item in field.radioOptions" ng-model="value[item.id]" ng-true-value="\'{{item.id}}\'" ng-value="item.id" aria-label="{{item.label}}" ng-checked="exists(item.id, value)" ng-click="toggleSelection(item.id, value)" >{{item.label}}</md-checkbox>' +
                '</md-list-item>' +
                '<md-list-item ng-if="field.readOnly === true"  class="custom-field-element">' +
                    '<md-checkbox ng-repeat="item in field.radioOptions|limitTo:1" aria-label="{{item.label}}" ng-model="value[item.id]" ng-true-value="\'{{item.id}}\'" ng-value="item.id" ng-checked="exists(item.id, value)" ng-click="toggleSelection(item.id, value)">{{field.name}}</md-checkbox>' +
                '</md-list-item>' +
                '</md-list>' +
            '</div>' +
            '<div class="angular-form-error col-xs-12" ng-if="errormessages.length">' +
                '<div class="error-message" ng-repeat="message in errormessages" ng-show="subModel.$error[message.key] && subModel.$dirty">{{message.message}}</div>' +
            '</div>' +
        '</div>',
        link: function($scope, element, attribute, ngModelCtrl){
            $scope.$watch(function(){
                return $(element).attr('class');
            }, function(){
                if($(element).hasClass('ng-dirty')){
                    $scope.isDirty = true;
                }
            });
            if($scope.type === $scope.types.date) {
                $scope.$watch(function () {
                    return $(element).val();
                }, function () {
                    if($(element).val()){
                        $(element)
                    }
                });
            }
            var errorMessages = _.pluck($scope.errormessages, 'key'),
                validateClosure,
                defaultDateFormat = [
                    'D/MM/YYYY','DD/MM/YYYY','D/M/YYYY','DD/M/YYYY','YYYY/MM/DD','YYYY/MM/D','YYYY/M/DD','YYYY/M/D',
                    'YYYY-MM-D','YYYY-MM-DD','YYYY-M-D','YYYY-M-DD',

                    'MM/DD/YYYY','MM/D/YYYY','M/DD/YYYY','M/D/YYYY','MM-DD-YYYY','MM-D-YYYY','M-DD-YYYY','M-D-YYYY',
                    'DD MMM YYYY','D MMM YYYY',
                ],
                parentContainer = $(element).parents('.route-view:first');

            // Link model with a sub model
            $scope.subModel = ngModelCtrl;

            // Custom field model validations
            validateClosure = function(ngModelValue){
                var valid = true,
                    tempValue = ngModelValue;

                // Remove any white space before or after the value
                if(angular.isString(tempValue)) {
                    tempValue = $.trim(tempValue);
                }

                if($scope.type === $scope.types.number && isNaN(ngModelValue)) {
                    ngModelValue = '';
                }

                // Validate base on the attributes that matches the case
                _.each($scope.attributes, function(attrValue, key){
                    $scope.subModel.$setValidity(key, true);
                    if(_.contains(errorMessages, key) === false || valid === false) {
                        return true;
                    }

                    // Custom validations base on the required field
                    switch (key){
                        // Check if field is required
                        case 'cfRequired':
                                tempValue = tempValue === '_empty' ? '' : ngModelValue;
                                valid = (angular.isArray(tempValue) ? tempValue.length !== 0 : tempValue !== '');
                            break;
                        // Check if email is valid
                        case 'cfEmail':
                                var emailRegExp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                                valid = tempValue === '' ? true : emailRegExp.test(tempValue);
                            break;
                        // Check if value is a number
                        case 'cfNumber':
                                var integerRegExp = /^(?:-?(?:0|[1-9][0-9]*))$/;
                                valid = tempValue === '' ? true : integerRegExp.test(tempValue);
                            break;
                        // Check if value is least then or equal to max value
                        case 'cfMax':
                                if(isNaN(tempValue)) {
                                    tempValue = 0;
                                } else {
                                    tempValue = parseFloat(tempValue)
                                }

                                if(isNaN(parseFloat(attrValue))) {
                                    attrValue = 0;
                                }
                                valid = $.trim(ngModelValue) === '' ? true : ngModelValue <= parseFloat(attrValue);
                            break;
                        // Check if value is greater then or equal to min value
                        case 'cfMin':
                                if(isNaN(tempValue)) {
                                    tempValue = 0;
                                } else {
                                    tempValue = parseFloat(tempValue)
                                }
                                if(isNaN(parseFloat(attrValue))) {
                                    attrValue = 0;
                                }
                                valid = tempValue === '' ? true : tempValue >= parseFloat(attrValue);
                            break;
                        // Check then char is less than the defined min length
                        case 'cfMinLength':
                                if(isNaN(parseFloat(attrValue))) {
                                    attrValue = 0;
                                }
                                valid = (ngModelValue === '') ? true : ngModelValue.length >= parseInt(attrValue, 10);
                            break;
                        // Check then char is less than the defined min length
                        case 'cfMaxLength':
                                if(isNaN(parseFloat(attrValue))) {
                                    attrValue = 0;
                                }
                                valid = tempValue === '' ? true : tempValue.length <= parseInt(attrValue, 10);
                            break;
                        case 'cfFlyBuys':
                                valid = true;
                                // valid = (tempValue === '') ? true : FlyBuys.valid(tempValue);
                            break;
                        case 'cfDate':
                            if(tempValue !== '') {
                                var validateDate = moment(tempValue, defaultDateFormat);
                                valid = validateDate.isValid();
                            }
                            break;
                        case 'cfMinDate':
                        case 'cfMaxDate':
                            if(tempValue !== '') {
                                var selectedDate = moment(tempValue, defaultDateFormat),
                                    validateMinDate = key === 'cfMinDate',
                                    validateDate = moment(attrValue, defaultDateFormat);

                                if(validateDate.isValid()){
                                    valid = validateMinDate ? selectedDate >= validateDate : selectedDate <= validateDate
                                }
                            }
                            break;
                        case 'cfMinAge':
                        case 'cfMaxAge':
                            if(tempValue !== '') {
                                var selectedDate = moment(tempValue, defaultDateFormat),
                                    compareDate = moment(),
                                    isMinAge = (key === 'cfMinAge'),
                                    compareWithSelector = ($scope.attributes.hasOwnProperty(key+'Field') ?
                                        $scope.attributes[key+'Field'] : false);

                                // Check if the date required to compare against another field
                                if (compareWithSelector && parentContainer.find('.' + compareWithSelector).length){
                                    var compareWith = parentContainer.find('.' + compareWithSelector);
                                    if(moment(compareWith.val(), defaultDateFormat, true).isValid()) {
                                        compareDate = moment(compareWith.val(), defaultDateFormat);
                                        // if($scope.account === 'docpermit'){
                                        //     var currentDate = moment();
                                        //     if (currentDate.month() < 6) {
                                        //         compareDate.subtract(1, 'year')
                                        //     }
                                        //     compareDate.month(6).date(1);
                                        // }
                                        if (typeof compareWith.data('validate-date') !== 'undefined' &&
                                            moment(compareWith.data('validate-date'), defaultDateFormat, true).isValid()
                                        ) {
                                            compareDate = moment(compareWith.data('validate-date'), defaultDateFormat);
                                        }
                                    }
                                }
                                // Check if the input is a number then convert the number to date
                                if (/^(?:-?(?:0|[1-9][0-9]*))$/.test(tempValue) && !selectedDate.isValid()) {
                                    selectedDate = compareDate.clone();
                                    selectedDate.subtract(tempValue, 'years');
                                }
                                compareDate.subtract(parseInt(attrValue, 10), 'years');
                                valid = isMinAge ? compareDate >= selectedDate : compareDate <= selectedDate;
                            }
                            break;
                        }

                    if(valid === true) {
                        $scope.subModel.$setValidity(key, true);
                    } else {
                        $scope.subModel.$setValidity(key, false);
                    }
                });

                return ngModelValue;
            }

            // Set custom field on changes
            element.on('keyup', '.custom-field-text', function(){
                var subModelValue = $(this).val();

                // make sure to pass in the correct value type
                if($scope.type === $scope.types.number) {
                    subModelValue = isNaN(subModelValue) ? 0 : parseFloat(subModelValue);
                }
                $scope.subModel.$setViewValue(subModelValue);
            });
            element.on('change', '.custom-field-date', function(){
                $scope.subModel.$setViewValue($(this).val());
            });
            // Set custom field on changes
            element.on('change', 'select', function(){
                $scope.subModel.$setViewValue($(this).val());
            });

            // Make sure the value for radio and checkbox store the correct value type (array)
            $scope.toggleSelection = function toggleSelection(item, existingValue) {
                var valueIndex      = existingValue.indexOf(item);

                // If not a multi selected then reset the value
                if($scope.field.multi !== true && $scope.type === $scope.types.radio) {
                    existingValue = [item];
                }
                // If a multi selected then check to either add or remove item
                else {
                    // is currently selected
                    if (valueIndex > -1) {
                        existingValue.splice(valueIndex, 1)
                    }
                    // is newly selected
                    else {
                        existingValue.push(item);
                    }
                }

                $scope.subModel.$setViewValue(existingValue);
            };

            $scope.exists = function (item, existingValue) {
                return angular.isArray(existingValue) && existingValue.indexOf(item) > -1;
            };
            // Set a custom parsers to validate on model changes
            $scope.subModel.$parsers.unshift(validateClosure);
            // Make sure the expected value is correct (array or string)
            $scope.subModel.$formatters.unshift(function(ngModelValue) {
                var fieldType = $scope.type;

                if(typeof ngModelValue === 'undefined'){
                    ngModelValue = null;
                }

                if(fieldType === $scope.types.date){
                    var momentDate = moment(ngModelValue)
                    ngModelValue = ''
                    if (momentDate.isValid()) {
                        ngModelValue = momentDate.toDate()
                    }
                } else if ([$scope.types.checkbox,$scope.types.radio].indexOf(fieldType) !== -1){
                    if(ngModelValue === null){
                        ngModelValue = [];
                    }
                    else if (!angular.isObject(ngModelValue)) {
                        ngModelValue = [ngModelValue];
                    }
                } else if (fieldType === $scope.types.number) {
                    ngModelValue = parseFloat(ngModelValue);
                }

                return ngModelValue;
            });

            $scope.subModel.$render = function() {
                var viewValue = $scope.subModel.$modelValue;
                if(typeof viewValue === 'undefined') {
                    viewValue = null;
                }

                // Making sure the value is return the correct type
                if ($scope.type === $scope.types.checkbox || $scope.type === $scope.types.radio) {
                    if (viewValue === null) {
                        viewValue = [];
                        $scope.subModel.$setViewValue(viewValue);
                    }
                }
                $scope.value = viewValue;
            };

        }
    }
});
